import { AWSEC2ComputeProviderInfo } from '../compute/aws-ec2';
import { DigitalOceanComputeProviderInfo } from '../compute/digitalocean';
import { LinodeComputeProviderInfo } from '../compute/linode';
import { WNextComputeProviderInfo } from '../compute/wnext';
import type { ComputeProviderInfo } from '../types';
import { ComputeProviderName } from '../types/Host';

export const firstPartyHosts: ComputeProviderInfo[] = [
  WNextComputeProviderInfo,
  // {
  //   id: 1,
  //   name: 'custom',
  //   title: 'Custom Host',
  //   description: 'Setup requires manual provisioning the required amount of space and command line use to invoke deployment. ',
  //   logo: CustomHostLogo,
  // },
];

export const thirdPartyHosts: ComputeProviderInfo[] = [
  LinodeComputeProviderInfo,
  DigitalOceanComputeProviderInfo,
  AWSEC2ComputeProviderInfo,
  // {
  //   id: 3,
  //   name: 'azure_virtual_machines',
  //   title: 'Azure Virtual Machines',
  //   description: 'Lorem ipsum',
  //   logo: AzureLogoSmall,
  // },
];

/**
 * All first and third party hosts
 */
export const allHosts = firstPartyHosts.concat(thirdPartyHosts);

/**
 * Reference to the wNext host provider
 */
export const wNextHost: ComputeProviderInfo = firstPartyHosts.find(
  (host) => host.id === ComputeProviderName.WNext
)!;

/**
 * Get host by ID
 *
 * @param id
 * @returns
 */
export function getHostByID(id: ComputeProviderName): ComputeProviderInfo | undefined {
  return allHosts.find((h) => h.id === id);
}
